import { App } from 'vue'
import VueHotjar from 'vue-hotjar-next'

import { appConfig } from '@/config'

export const initHotjar = (app: App<Element>) => {
  if (!appConfig.hotjar?.id) return

  app.use(VueHotjar, {
    id: appConfig.hotjar.id,
    isProduction: appConfig.env === 'production',
  })
}
